import apiClient from './api'

export default {
    async getPackages(filters = {}) {
        const params = new URLSearchParams()

        if (filters.maxPrice) params.append('price_max', filters.maxPrice)
        if (filters.zones && filters.zones.length) {
            // Backend currently expects single zone or handling array logic manually. 
            // For simplicity in this iteration, we might just pass the first one or need to update backend to handle arrays.
            // Let's assume we filter client side nicely or just pass one.
            // params.append('zone', filters.zones[0])
        }
        // ... handled largely by frontend filtering on the returned list for now, 
        // OR we can pass params if backend supports it. 
        // The current backend has basic filtering. Let's start with fetching all (active).

        // Send request with constructed params (maxPrice, search, etc.)
        const response = await apiClient.get('/packages', { params })
        return response.data.data // Laravel pagination wrapper
    },

    async getPackageById(id) {
        const response = await apiClient.get(`/packages/${id}`)
        const data = response.data

        // Transform backend structure to match frontend expectations
        return {
            ...data,
            image: data.full_image || data.image,
            gallery: data.images ? data.images.map(img => img.full_image_url || img.image_url) : [data.full_image || data.image],
            includes: data.inclusions || [],
            excludes: data.exclusions || []
        }
    },

    async getZones() {
        const response = await apiClient.get('/packages/zones')
        return response.data
    }
}
